import IdleWarning from './IdleWarning';

export default IdleWarning;
